import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { PlaylistSong, soundEffect } from "../../common/constants";
interface AudioState {
  isPlay: boolean;
  isRepeat: boolean;
  isSpotify: boolean;
  currentIndexSong: number;
  volumeValue: number;
  levelSound: number;
  soundEffect: {
    id: number;
    type: string;
    source: string;
    icon: string;
    levelSound: number;
  }[];
  inforSongPlayer: {
    songId?: number;
    name: any;
    thumbnail?: string;
  };
  playlist: any;
}
const initialState: AudioState = {
  isPlay: false,
  isRepeat: false,
  isSpotify: false,
  currentIndexSong: 0,
  playlist: PlaylistSong[0],
  volumeValue: 50,
  levelSound: 0.5,
  soundEffect: soundEffect,
  inforSongPlayer: {
    name: PlaylistSong[0]?.songs[0]?.name,
    thumbnail: "",
  },
};

export const audioSlice = createSlice({
  name: "audio",
  initialState,
  reducers: {
    getPlaylist: (state, action: PayloadAction<any>) => {
      state.playlist = action.payload;
    },
    setInfoSongPlayer: (state, acion) => {
      state.inforSongPlayer = acion.payload;
    },
    setPlay: (state, action) => {
      state.isPlay = action.payload;
    },

    setplaylistSpotify: (state, action) => {
      state.isSpotify = action.payload;
    },
    setCurrentIndexSong: (state, action) => {
      state.currentIndexSong = action.payload;
    },
    setRepeat: (state, action) => {
      state.isRepeat = action.payload;
    },
    setValueVolume: (state, action) => {
      state.volumeValue = action.payload;
    },
  },
});

export const {
  getPlaylist,
  setPlay,
  setplaylistSpotify,
  setInfoSongPlayer,
  setCurrentIndexSong,
  setRepeat,
  setValueVolume,
} = audioSlice.actions;

export default audioSlice.reducer;
